/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_ResultInputs */

const en_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const de_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const fr_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const es_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const it_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const nl_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const pl_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const fi_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const da_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const sv_story_bank_label_result = /** @type {(inputs: Story_Bank_Label_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

/**
* | output |
* | --- |
* | "Result" |
*
* @param {Story_Bank_Label_ResultInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_result = /** @type {((inputs?: Story_Bank_Label_ResultInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_ResultInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_result(inputs)
	if (locale === "fr") return fr_story_bank_label_result(inputs)
	if (locale === "es") return es_story_bank_label_result(inputs)
	if (locale === "it") return it_story_bank_label_result(inputs)
	if (locale === "nl") return nl_story_bank_label_result(inputs)
	if (locale === "pl") return pl_story_bank_label_result(inputs)
	if (locale === "fi") return fi_story_bank_label_result(inputs)
	if (locale === "da") return da_story_bank_label_result(inputs)
	if (locale === "sv") return sv_story_bank_label_result(inputs)
	return en_story_bank_label_result(inputs)
});